import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-row nowrap text-primary-orange",
  style: {"gap":"6px"}
}

import ErrorExclamationSvg from '@/components/LoginRegister/svg/ErrorExclamationSvg.vue'

interface Props {
    text?: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'FieldError',
  props: {
    text: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(ErrorExclamationSvg, { color: 'var(--primary-orange)' })
    ]),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(props.text), 1)
      ])
    ])
  ]))
}
}

})